<div style="font-size: xx-large;" class="spinner-border text-light" role="status">
    <span class="sr-only">Loading...</span>
</div>